import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import { 
  setConnectionStatus, 
  resetReconnectAttempts 
} from '../store/slices/websocketSlice';
import websocketService from '../services/websocket';

const WebSocketManager: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { token, isAuthenticated } = useSelector((state: RootState) => state.auth);
  const { isConnected } = useSelector((state: RootState) => state.websocket);

  useEffect(() => {
    if (!isAuthenticated || !token) {
      return;
    }

    let active = true;
    dispatch(setConnectionStatus('connecting'));
    dispatch(resetReconnectAttempts());

    // setTimeout(0) absorbs React StrictMode's double-invoke: cleanup cancels
    // the first timer before it fires, so connect() runs exactly once.
    const timer = setTimeout(() => {
      if (active) {
        websocketService.connect();
      }
    }, 0);

    return () => {
      active = false;
      clearTimeout(timer);
      websocketService.disconnect();
      dispatch(setConnectionStatus('disconnected'));
    };
    // token намеренно не в deps: websocketService.connect() всегда читает свежий
    // токен из store в момент подключения, а baseQueryWithReauth молча обновляет
    // token на каждый 401 (не только auth-запросы) — если реагировать на его
    // смену здесь, живой сокет рвался бы и переоткрывался на ровном месте.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, dispatch]);

  // Мониторим статус соединения
  useEffect(() => {
    const checkConnection = () => {
      const status = websocketService.getConnectionStatus();
      if (status && !isConnected) {
        dispatch(setConnectionStatus('connected'));
      } else if (!status && isConnected) {
        dispatch(setConnectionStatus('disconnected'));
      }
    };

    // Проверяем статус каждые 5 секунд
    const interval = setInterval(checkConnection, 5000);
    
    return () => clearInterval(interval);
  }, [isConnected, dispatch]);

  // Этот компонент не рендерит UI, только управляет WebSocket
  return null;
};

export default WebSocketManager; 
